import React from "react";
import { useTranslation } from "react-i18next";
import Paper from "@mui/material/Paper";

const NoInvoices = () => {
  const { t } = useTranslation();

  return (
    <Paper elevation={3} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '25px' }}>
      {t("youStillHaveNoInvoices")}
    </Paper>
  );
};

export default NoInvoices;
